import eventBus from "@/eventBus";
import { $t } from "@/i18n";

export function errorHandler(
  error: Error & { data?: { code?: string; message?: string } },
  options?: { customTitle?: string; customText?: string }
) {
  let notification = { title: "", text: "", error: true, rawMessage: "" };
  
  if(error.data?.code){
    notification.title = $t(`errors.${error.data.code}-title`);
    notification.text = $t(`errors.${error.data.code}-text`);
  } else {
    notification.title = $t("errors.default-title");
    notification.text = $t("errors.default-text");
  }
  if (error.data?.message) notification.rawMessage = error.data.message;
  
  if (options?.customTitle) notification.title = $t(`errors.${options.customTitle}`);
  if (options?.customText) notification.text = $t(`errors.${options.customText}`);


  eventBus.emit("displayinfo", notification);
  
  return notification;
}
